import React, { FC, useEffect } from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'
import './Products.scss'
import productService from 'Services/productService'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'

type UpdatePriceProps = {
  id: string
  setEditingRow: (value: string | null) => void
  setEditPrice: (value: number) => void
  refresh: () => void
  editPrice: number
  editSellingPrice: number
  productId: string
}

type FormValues = {
  unitCostPrice: number
  unitSellingPrice: number
}

const UpdatePrice: FC<UpdatePriceProps> = ({
  id,
  setEditingRow,
  setEditPrice,
  editPrice,
  editSellingPrice,
  productId,
  refresh,
}) => {
  const { showAlert } = ShowTGAlert()

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>({
    defaultValues: {
      unitCostPrice: editPrice,
      unitSellingPrice: editSellingPrice,
    },
  })

  const onSubmit: SubmitHandler<FormValues> = async (formData) => {
    await productService
      .setProductRate(id, {
        unitCostPrice: formData.unitCostPrice.toString(),
        unitSellingPrice: formData.unitSellingPrice.toString(),
        productId: productId.toString(),
        isHidden: '',
      })
      .then(
        () => {
          setEditingRow(null)
          refresh()
        },
        (error) => {
          showAlert({
            message: error.response.data.error,
            show: true,
            title: 'Error',
            type: 'error',
          })
        },
      )
  }
  useEffect(() => {
    setValue('unitCostPrice', editPrice)
    setValue('unitSellingPrice', editSellingPrice)
  }, [editPrice, editSellingPrice])

  return (
    <div className='price-edit-tooltip' onClick={(e) => e.stopPropagation()}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='mb-2'>
          <label htmlFor={`selling-${id}`} className='form-label'>
            Selling Price
          </label>
          <input
            id={`selling-${id}`}
            type='number'
            className='form-control'
            min={0}
            step='any'
            inputMode='decimal'
            {...register('unitSellingPrice', {
              required: 'Selling price is required',
              valueAsNumber: true,
              min: { value: 0, message: 'Must be 0 or greater' },
            })}
          />
          {errors.unitSellingPrice && (
            <p className='text-danger'>{errors.unitSellingPrice.message}</p>
          )}
        </div>

        <div className='mb-2'>
          <label htmlFor={`cost-${id}`} className='form-label'>
            Cost Price
          </label>
          <input
            id={`cost-${id}`}
            type='number'
            step='any'
            className='form-control'
            min={0}
            {...register('unitCostPrice', {
              required: 'Cost price is required',
              valueAsNumber: true,
              min: { value: 0, message: 'Must be 0 or greater' },
            })}
          />
          {errors.unitCostPrice && <p className='text-danger'>{errors.unitCostPrice.message}</p>}
        </div>

        <div className='d-flex gap-2'>
          <button
            type='submit'
            className='btn btn-default border-0 btn-sm rounded'
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </button>

          <button
            type='button'
            className='btn btn-white text-danger border-0 btn-sm'
            onClick={() => setEditingRow(null)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  )
}

export default UpdatePrice
